import { canv } from "@/canv/global.js";
import { setClick } from "@/canv/utils.js";

export class CursorTrackingWindow {
    open(sessionUID: string) {
        const cursorFollowInviteUser = canv.multiManager.multiUsers.find(
            (user) => user.sessionUID === sessionUID,
        );

        if (!cursorFollowInviteUser) return;

        this.close();

        this.name = cursorFollowInviteUser.name;
        this.sessionUID = sessionUID;

        const cursorTrackingWindowWrapper = document.createElement("div");
        cursorTrackingWindowWrapper.classList.add("cursorTrackingWindowWrapper");
        document.body.prepend(cursorTrackingWindowWrapper);

        cursorTrackingWindowWrapper.innerHTML += this.getTemplate();

        this.init();
    }

    // cursorTrackingWindow

    close() {
        const cursorTrackingWindowWrapper = document.getElementsByClassName(
            "cursorTrackingWindowWrapper",
        )[0] as Element | undefined;
        if (cursorTrackingWindowWrapper !== undefined) {
            cursorTrackingWindowWrapper.outerHTML = "";
        }

        this.name = "";
        this.sessionUID = null;
    }

    init() {
        setClick("cancelTrackingBtn", this.cancelTrackingClick.bind(this));
        setClick("acceptTrackingBtn", this.acceptTrackingClick.bind(this));
    }

    // Proccessors

    cancelTrackingClick() {
        this.close();
    }

    acceptTrackingClick() {
        if (canv.multiManager.multiUsers.length) {
            canv.multiManager.TryViewSubscribe(this.sessionUID);
        }
        this.close();
    }

    // Templates

    getTemplate() {
        return `
            <div class="cursorTrackingWindow">
                <div class="cursorTrackingWindowInfo">Пользователь ${this.name}<br>предлагает отслеживать его действия на доске</div>
                <div class="cursorTrackingBtns">
                  <div class="acceptTrackingBtn">Согласиться</div>
                  <div class="cancelTrackingBtn">Отказаться</div>
                </div>

            </div>
        `;
    }

    sessionUID: string | null = null;
    name = "";
}
